import React from "react";
import {DatePicker, Form, FormInstance, Modal} from "antd";
import Locale from "../../../../../core/locale/locale";
import dayjs, {Dayjs} from "dayjs";

interface IOverdueModalProps {
    open: boolean,
    handleRenewModalClose: () => void;
    assetOverdueForm: FormInstance;
    handleRenewSubmit: () => void;
}

const OverdueModal = (props: IOverdueModalProps) => {

    const disableDate = (currentDate: Dayjs) => (
        //disable past date
        currentDate.valueOf() <= dayjs().startOf('day').valueOf()
    );

    return (
        <Modal
            className={'hrms-app asset-overdue-modal'}
            title={"Extend Expected Return Date"}
            open={props.open}
            onCancel={props.handleRenewModalClose}
            onOk={props.handleRenewSubmit}
        >
            <Form form={props.assetOverdueForm}>
                <Form.Item
                    className={"updated-expected-return-date"}
                    rules={[{required: true, message: 'Please choose date!'}]}
                    name={'updatedExpectedReturnDate'}
                >
                    <DatePicker format={Locale.displayDate} disabledDate={disableDate}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default OverdueModal;
